// amplifyConfig.js
import { Auth } from "aws-amplify";

async function idTokenHeader() {
  try {
    const session = await Auth.currentSession(); // throws if no auth yet
    const idToken = session.getIdToken().getJwtToken();
    return {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    };
  } catch {
    // Stop the request instead of sending it without Authorization
    throw new Error("NO_AUTH");
  }
}

const amplifyConfig = {
  Auth: {
    region: process.env.REACT_APP_AWS_REGION_COGNITO,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,

    cookieStorage:
      process.env.REACT_APP_ENV === "local"
        ? undefined
        : {
            domain: `${process.env.REACT_APP_COOKIE_DOMAIN}`,
            expires: 30,
            path: "/",
            sameSite: "lax",
            secure: true,
          },

    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN,
      scope: (process.env.REACT_APP_OAUTH_SCOPES || "openid email profile").split(" "),
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN || `${window.location.origin}/`,
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT || `${window.location.origin}/`,
      responseType: "code",
    },
  },

  API: {
    endpoints: [
      {
        name: "AccountGatewayApi",
        endpoint: `https://${process.env.REACT_APP_ACCOUNT_API_URL}`,
        custom_header: idTokenHeader,
      },
      {
        name: "OpenQueryAPI",
        endpoint: `https://${process.env.REACT_APP_OPEN_QUERY_API_URL}`,
        custom_header: idTokenHeader,
      },
      {
        name: "FileApi",
        endpoint: `https://${process.env.REACT_APP_FILE_MANAGEMENT_API_URL}`,
        custom_header: idTokenHeader, // normalized to Bearer format
      },
      {
        name: "MonitoringServiceApi",
        endpoint: `https://${process.env.REACT_APP_MONITORING_SERVICE_API_URL}`,
        custom_header: idTokenHeader,
      },
      {
        name: "CommunityApi",
        endpoint: `https://${process.env.REACT_APP_COMMUNITY_API_URL}`,
        custom_header: idTokenHeader,
      },
      {
        name: "NpiApi",
        endpoint: `https://${process.env.REACT_APP_NPI_API_URL}`,
        custom_header: idTokenHeader,
      },
      {
        name: "DashboardApi",
        endpoint: `https://${process.env.REACT_APP_DASHBOARD_API_URL}`,
        custom_header: idTokenHeader,
      },
    ],
  },

  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export default amplifyConfig;
